function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPathwaysIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6200000047683716
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 5,
    style: {
      fill: "#eebf37"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.37,4A20.75,20.75,0,0,0,29.62,24.75C29.62,46.14,50.37,64,50.37,64S71.12,46.14,71.12,24.75A20.75,20.75,0,0,0,50.37,4Zm0,25.68a8.31,8.31,0,1,1,8.31-8.31,8.31,8.31,0,0,1-8.31,8.31Z",
    style: {
      fill: "#fff",
      stroke: "#edbf35",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,92H63.6a7,7,0,0,0,7-7h0a7,7,0,0,0-7-7H17.48a7,7,0,0,1-7-7h0a7,7,0,0,1,7-7H35",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.64,
    y1: 64.2,
    x2: 91,
    y2: 64.2,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPathwaysIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pathways-icon.a75ab140.svg";
export { ForwardRef as ReactComponent };